import isEmail from 'validator/lib/isEmail';
import { ACCOUNT_SETTINGS } from '../../config';
import i18n from 'i18n/i18n';

const localize = i18n.loc.localize;

const consecutiveSpacesRegex = new RegExp(/ {2,}/);
const leadingTrailingSpacesRegex = new RegExp(/^ | $/);

const schema = {
	'newEmail': (value, state) => {
		if (!value) {
			return localize('required-field');
		}
		if (state.touched['newEmail']) {
			if (!isEmail(value)) {
				return localize('account-email-invalid');
			}
			if (state.currentEmail === value) {
				return localize('account-email-the-same');
			}
		}
	},
	'newFirstName': (value, state) => {
		if (!value) {
			return localize('required-field');
		}
		if (state.touched['newFirstName']) {
			if (consecutiveSpacesRegex.test(value)) {
				return localize('account-name-consecutive-spaces');
			}
			if (leadingTrailingSpacesRegex.test(value)) {
				return localize('account-name-first-leading-trailing-spaces');
			}
		}
	},
	'newLastName': (value, state) => {
		if (!value) {
			return localize('required-field');
		}
		if (state.touched['newLastName']) {
			if (consecutiveSpacesRegex.test(value)) {
				return localize('account-name-consecutive-spaces');
			}
			if (leadingTrailingSpacesRegex.test(value)) {
				return localize('account-name-last-leading-trailing-spaces');
			}
		}
	},
	'newPassword': (value, state) => {
		if (state.touched['newPassword']) {
			if (!value) {
				return localize('required-field');
			}
			if (value.length < ACCOUNT_SETTINGS.minPasswordLength) {
				return localize('account-password-too-short', ACCOUNT_SETTINGS.minPasswordLength);
			}
			if (value.length > ACCOUNT_SETTINGS.maxPasswordLength) {
				return localize('account-password-too-long', ACCOUNT_SETTINGS.maxPasswordLength);
			}
		}
	},
	'confirmNewPassword': (value, state) => {
		if (state.touched['confirmNewPassword']) {
			if (!value) {
				return localize('required-field');
			}			
			if (value.length < ACCOUNT_SETTINGS.minPasswordLength) {
				return localize('account-password-too-short', ACCOUNT_SETTINGS.minPasswordLength);
			}
			if (value.length > ACCOUNT_SETTINGS.maxPasswordLength) {
				return localize('account-password-too-long', ACCOUNT_SETTINGS.maxPasswordLength);
			}
		}
	},	
};

export default schema;


// WEBPACK FOOTER //
// ./src/containers/AccountDetails/AccountDetailsSchema.js